import { useInstantSearch } from 'react-instantsearch';

import Icon from '@klv/atoms/icon';

import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';
import useAlgoliaHits from '@klv/organisms/unified-search/hooks/use-algolia-hits';

import * as styles from './styles/unifiedSearchNoResults.module.css';
import useSelectedSearches from './hooks/useSuggestedSearches';
import type { IUnifiedSearchNoResults } from './types';

export const NoResults = ({
  className = '',
  query,
  ...props
}: IUnifiedSearchNoResults) => {
  
  const { t } = useTranslation();

  const suggestedSearches = useSelectedSearches();

  const updateSearch = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target: HTMLAnchorElement = e.target as HTMLAnchorElement;
    const url = new URL(location?.href || '');
    url.searchParams.set('query', target.innerText);
    window.location.href = url.toString();
  };

  return (
    <div className={generateClassName([className, styles.unifiedSearchNoResults])} {...props}>
      <div className={styles.title}>{t('pages_search_noResultsTitle', { query })}</div>
      <div className={generateClassName([styles.subTitle, 'p2'])}>{t('pages_search_noResultsSubTitle')}</div>
      
      <div className={styles.suggestedSearchesTitle}>{t('pages_search_suggestedSearchesTitle')}</div>
      <ul className={styles.suggestedSearches}>
        {suggestedSearches.map((search)=>(
          <li key={search}>
            <Icon color='currentColor' iconName='Search' />
            <a className="p2" href="#" onClick={updateSearch}>
              {search}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const UnifiedSearchNoResults = (props: IUnifiedSearchNoResults) => {
  const { uiState } = useInstantSearch();
  const { totalHits } = useAlgoliaHits();
  const query = Object.values(uiState).find(child => child.query)?.query || '';
  
  if (!query || totalHits > 0) return null;

  return <NoResults {...props} query={query} />;
};

export default UnifiedSearchNoResults;
